<template>
    <div class="course-main">

        <div class="course-card">
            <div class="course-pic" id="web">
                <img src="../../assets/shenoy2.png" width="200" id="image">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b id="name">Aditya Shenoy</b><br>
                    <p id="desig">
                        Team CodeGill
                    </p> 
                    <p>Founder</p>
                </div>
            </div>
        </div>
        <div class="course-card">
            <div class="course-pic" id="game">
                <img src="../../assets/anushka2.png" width="200" id="image">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b id="name">Anushka Pai</b><br>
                    <p id="desig">
                        Team CodeGill
                    </p>
                    <p>Co-Founder</p>
                    
                </div>
            </div>
        </div>
        <div class="course-card">
            <div class="course-pic" id="python">
                <img src="../../assets/praneet.png" width="200" id="image">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b id="name">Praneet Acharya</b><br>
                    <p id="desig">
                        Team CodeGill
                    </p>
                    <p>Co-Founder</p>
                    
                </div>
            </div>
        </div>
        <div class="course-card">
            <div class="course-pic" id="cpp">
                <img src="../../assets/Adityak.png" width="200" id="image">
            </div>
            <div class="course-bottom">
                <div class="course-bottom-text">
                    <b id="name">Aditya Kamath S</b><br>
                    <p id="desig">
                        Team CodeGill
                    </p>
                    <p>Co-Founder</p>
                    
                </div>
            </div>
        </div>
        
    </div>    
</template>



<script>
export default {
   name:'TeamCards' 
}
</script>


<style scoped>

    #desig{
        font-size: 1.1em;
        font-weight: 300;
        color: rgb(95, 93, 93);
    }
    #name{
        font-size: 1.5em;
    }
    #image{
        margin-top: -6rem;
        border-radius: 50%;
        margin-bottom: 1rem;
        border: 2px solid white;
        background-color: white;
        box-shadow: 0rem  0.1rem 0.4rem 0.3rem rgb(233, 232, 232);
         pointer-events: none;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
         user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
    }   
    
    .course-main{   
        margin-top: 3.5rem;
        display:grid;
        grid-template-columns:auto auto;
        justify-content: center;
    }   
    .course-card{
        width: 18rem;
        height: 18rem;
        margin: 0.5rem;
        margin-top: 7rem;
        background-color: white;
        /* border: 2px solid rgb(221, 219, 219); */
        border-radius: 0.3rem;
        box-shadow: 0 2px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    }

    .course-card:hover{
         box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }

    .course-pic{
       
       /* border: 2px solid rgb(238, 236, 236); */
       border-radius: 0.3rem;
      
       display: flex;
       justify-content: center;
       align-items: center;
       border-radius: 0.3rem;
       

    }

    .course-bottom-text{
        height: 80%;
        padding: 0.5rem;
        color: #1c1b1b;
        font-family: 'Josefin Sans', sans-serif;
        font-size: 1em;
        font-weight: 400;
        text-align: center;
    }

    .preview-btn{
        height: 2rem;
        margin-top:0.3rem ;
        border-radius: 0.1rem;
        border: 0;
        color: rgb(47, 22, 22);
        font-weight: 500;
        font-family: 'Josefin Sans', sans-serif;
        font-size: 1em;
        box-shadow: 0 2px 2px 0 rgb(160, 160, 160);
        background-color: #ffca0b;
    }
    .preview-btn:hover{
        background-color: #eeb12e;
    }

    @media screen and (max-width:768px){
        

        .course-main{
        margin-top: 3.5rem;
        display:grid;
        grid-template-columns:auto;
        justify-content: center;
    }   
    .course-card{
        width: 17rem;
        height: 15rem;
        margin: 0.5rem;
        border: 2px solid rgb(221, 219, 219);
        margin-top: 7.5rem;
        border-radius: 0.3rem;
        box-shadow: 0 2px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    }

    .course-card:hover{
         box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }

    .course-pic{
       height: 40%;
       /* border: 2px solid rgb(238, 236, 236); */
       
    }

    .course-bottom-text{
        height: 60%;
        padding: 0.5rem;
        color: #1c1b1b;
        font-family: 'Josefin Sans', sans-serif;
        font-size: 1em;
        font-weight: 400;
    }


    }
</style>